var SwiperCardBlog = new Swiper(".content-card-blog", {
  slidesPerView: 3,
  spaceBetween: 14,
  breakpoints: {
    800: {
      slidesPerView: 3, // el .3 hace que se asome el siguiente slide
      spaceBetween: 12,
    },
    568: {
      slidesPerView: 1.2, // el .2 hace que se asome el siguiente slide
      spaceBetween: 10,
    },
    0: {
      slidesPerView: 'auto', // para móviles muy pequeños
      spaceBetween: 16,
    },
  },
  // Opcional: para que no se centre el slide activo
  centeredSlides: false,
});
